export default __webpack_public_path__ + "static/media/title-pensando.6d971558.png";